import {inject, injectable} from 'inversify';

import type {Expand, MaybeExpanded} from '../../../../api/types';
import type {PaymentMapperJrpc} from '../../Payment/mappers/Payment.mapper.jrpc';

import {omitExpand} from '../../../../api/utils/expand';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';
import {PaymentExpandJrpc} from '../../Payment/mappers/Payment.expand.jrpc';

@injectable()
export class RefundExpandJrpc extends BaseExpandJrpc {
  constructor(
    @inject(EnvProviderService) env: EnvProviderService,
    @inject(PaymentExpandJrpc)
    private readonly paymentExpand: PaymentExpandJrpc,
  ) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = {
      refund: [
        [
          'refund_payment_id->refund_payment',
          null,
          this.getRefundPaymentExpand(key),
        ],
        ['payment_id', null, this.getRefundPaymentExpand(key)],
      ],
    };
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }

  private getRefundPaymentExpand(key?: BaseExpandJrpc.EnvKey): Expand {
    return omitExpand(this.paymentExpand.getByEnv(key), ['refund_ids']);
  }
}

export namespace RefundExpandJrpc {
  export type ExpandedFields = {
    payment: MaybeExpanded<Omit<PaymentMapperJrpc.ExpandedApiData, 'refunds'>>;
    refund_payment: MaybeExpanded<
      Omit<PaymentMapperJrpc.ExpandedApiData, 'refunds'>
    >;
  };
}
